import { render, staticRenderFns } from "./Advertisers.vue?vue&type=template&id=08b0f76c&"
import script from "./Advertisers.vue?vue&type=script&lang=js&"
export * from "./Advertisers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports